const getFlag = (key) => (state) => state.flags[key]

export default {
  getFlag
}
